<template>
  <nav
    class="c-building-nav"
  >
    <button
      v-if="selectedBuilding !== 'all'"
      @click="close()"
      @keyup.enter="close()"
      type="button"
      class="c-btn c-btn--primary c-btn--has-icon"
      aria-label="Tilbake til oversikt"
    >
      <icon-left
        class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
      />
      Oversikt
    </button>
    <transition
      v-if="showBuildingName === true"
      name="building-nav-fade"
      mode="out-in"
    >
      <p class="c-building-nav__header c-building-nav__header--big">
        {{ name }}
      </p>
    </transition>
    <transition
      v-else
      name="building-nav-fade"
      mode="out-in"
    >
      <select-building
        class="c-select c-select--center c-select--big c-building-nav__header c-building-nav__header--big"
      />
    </transition>
  </nav>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

// Data models
import Building from '@/models/Building';
import Illustration from '@/models/Illustration';

// Components
import SelectBuilding from '@/components/SelectBuilding.vue';
import IconLeft from '@/components/icons/IconLeft.vue';


export default {
  name: 'BuildingNavigation',
  components: {
    SelectBuilding,
    IconLeft,
  },
  data() {
    return {
      hoveredBuildingId: 0,
      showBuildingName: false,
    };
  },
  computed: {
    name() {
      let name = '';
      if (this.showBuildingName === true) {
        const building = Building.query()
          .with('availability')
          .whereId(this.hoveredBuildingId)
          .first();
        if (building.availability.slug === 'for-sale') {
          name = building.name;
        } else {
          name = building.name + ' – ' + building.availability.name;
        }
        return name;
      } else {
        return name;
      }
    },
    selectedBuilding() {
      return this.$store.state.entities.buildings.selectedBuilding;
    },
  },
  created() {
    EventBus.$on('building-focus', focus => {
      if (focus.name) {
        this.showBuildingName = focus.hasFocus;
        this.hoveredBuildingId = focus.id;
      } else {
        this.showBuildingName = false;
        this.hoveredBuildingId = 0;
      }
    });
  },
  methods: {
    close() {
      Building.commit(state => {
        state.selectedBuilding = 'all';
      });
      Illustration.commit(state => {
        state.currentSection = 'all';
      });
      localStorage.setItem('selectedBuilding', 'all');
    },
  },
};
</script>
